var React = require('react');

function UserHomeLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 23.005a6.5 6.5 0 116.5-6.5 6.51 6.51 0 01-6.5 6.5zm0-11a4.5 4.5 0 100 9 4.5 4.5 0 000-9z","key":0}),React.createElement("path",{"d":"M27 48.005h-6a1 1 0 01-1-.92l-.75-9.08H17a1 1 0 01-1-1v-6a8 8 0 1116 0v6a1 1 0 01-1 1h-2.25l-.75 9.08a1 1 0 01-1 .92zm-5.08-2h4.16l.76-9.09a1 1 0 011-.91h2.17v-5a6 6 0 10-12 0v5h2.17a1 1 0 011 .91l.74 9.09z","key":1}),React.createElement("path",{"d":"M45 48.005H33a1 1 0 110-2h12a1 1 0 001-1v-27.4a1 1 0 00-.43-.83l-21-14.59a1 1 0 00-1.14 0l-21 14.59a1 1 0 00-.43.83v27.4a1 1 0 001 1h12a1 1 0 110 2H3a3 3 0 01-3-3v-27.4a3 3 0 011.29-2.47l21-14.6a3 3 0 013.42 0l21 14.6a3 3 0 011.29 2.47v27.4a3 3 0 01-3 3z","key":2})]);
}

UserHomeLight.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = UserHomeLight;

UserHomeLight.default = UserHomeLight;
